export default "__VITE_ASSET__451e3f89__"